import { cva } from "class-variance-authority"

export const typographyVariants = cva("font-sans", {
  variants: {
    variant: {
      headline: "text-headline",
      subheadline: "text-subheadline",
      title: "text-title",
      subtitle: "text-subtitle",
      heading: "text-heading",
      subheading: "text-subheading",
      body1: "text-body1",
      body2: "text-body2",
      caption: "text-caption",
      metadata: "text-metadata",
    },
    weight: {
      bold: "font-bold",
      medium: "font-medium",
      regular: "font-normal",
      light: "font-light",
    },
  },
  defaultVariants: {
    variant: "body1",
    weight: "regular",
  },
})

export const typographyTags = {
  headline: "h1",
  subheadline: "h2",
  title: "h2",
  subtitle: "h3",
  heading: "h4",
  subheading: "h5",
  body1: "p",
  body2: "p",
  caption: "span",
  metadata: "span",
} as const

export type TypographyVariant = keyof typeof typographyTags
export type TypographyWeight = "bold" | "medium" | "regular" | "light"
